import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, BrowserRouter as Router, Switch, useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import "./App.css";
import { loginRequest, msalConfig } from "./authConfig";
import ApproverPage from "./function-components/ApprovalComponent/ApproverPage";
import Footer from "./function-components/Footer";
import Container from "./function-components/LaunchComponent/Container";
import { PageLayout } from "./function-components/PageLayout";
import { handleUserIDSave } from "./function-components/Redux/Mailer";
import { getTrack } from "./function-components/Redux/TrackSlice";
import SearchNav from "./function-components/Searchnav";
import { CustomNavigationClient } from "./utils/NavigationClient";
import ChatBot from "././function-components/ChatBot/index";
function App({
  pca
}) {
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);
  pca.setNavigationClient(navigationClient);
  return <MsalProvider instance={pca}>
   <PageLayout>
    <div justify="center">
     <Pages />
    </div>
   </PageLayout>
  </MsalProvider>;
}
function Pages() {
  const [allReset, setAllReset] = useState(false);
  const msalInstance = new PublicClientApplication(msalConfig);
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const dispatch = useDispatch();
  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
      dispatch(handleUserIDSave(activeAccount.idTokenClaims.enterpriseID));
    }
    createSession();
  }, [activeAccount]);
  useEffect(() => {
    dispatch(getTrack());
  }, []);

  //old method
  const fetchAccessToken = async () => {
    if (!activeAccount) throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount
      });
      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };
  function createSession() {
    const sessionId = uuidv4();
    localStorage.setItem("sessionId", sessionId);
    return sessionId;
  }
  const DowntimeMessage = ({
    message = "We are currently experiencing an unexpected issue with Commsbuilder Application. Our team is actively investigating the problem, but the estimated time for resolution is not yet known. We apologize for any inconvenience this may cause and appreciate your patience as we work to resolve the issue."
  }) => {
    return <div className="migrated-style-app-0bdc7e-1">
    <h1>🚧 Important Notice: Application Downtime</h1>
    <p>{message}</p>
   </div>;
  };
  return <Router>
   <SearchNav allReset={allReset} setAllReset={setAllReset} />
   <Switch>
    <Route exact path="/">
     {/* <DowntimeMessage /> */}
     <Container allReset={allReset} setAllReset={setAllReset} />
    </Route>

    <Route exact path="/lead">
     <ApproverPage />
    </Route>
    <Route exact path="/home">
     <Container />
    </Route>
    <Route exact path="/chatbot">
     <ChatBot />
    </Route>
   </Switch>
   <Footer />
  </Router>;
}
export default App;
